
import React from 'react';
import { ExternalLink } from 'lucide-react';
import ScrollReveal from '../ui/ScrollReveal';
import { Button } from '@/components/ui/button';

const ShowcaseSection = () => {
  const projects = [
    {
      title: "The Vladimir Collection",
      category: "Luxury Real Estate",
      desktopImage: "https://app.milanote.com/media/p/images/1TZl4J1uaXLgcv/VFq/combined_screenshots_with_drawing%20%288%29.jpg",
      mobileImage: "https://app.milanote.com/media/p/images/1TZl4J1uaXLgcv/VFq/combined_screenshots_with_drawing%20%288%29.jpg",
      description: "Luxury real estate website design"
    },
    {
      title: "Pinnacle Roofing",
      category: "Construction",
      desktopImage: "https://app.milanote.com/media/p/images/1TZl4J1uaXLgcw/HWE/combined_screenshots_with_drawing%20%289%29.jpg",
      mobileImage: "https://app.milanote.com/media/p/images/1TZl4J1uaXLgcw/HWE/combined_screenshots_with_drawing%20%289%29.jpg",
      description: "Full brand identity and website redesign"
    },
    {
      title: "H.A. May Construction",
      category: "Construction",
      desktopImage: "https://app.milanote.com/media/p/images/1TZlHu1uaXLgcx/1pk/combined_screenshots_with_drawing%20%2810%29.jpg",
      mobileImage: "https://app.milanote.com/media/p/images/1TZlHu1uaXLgcx/1pk/combined_screenshots_with_drawing%20%2810%29.jpg",
      description: "Construction company brand refresh and website"
    },
    {
      title: "Cagley Homes",
      category: "Home Builders",
      desktopImage: "https://app.milanote.com/media/p/images/1TZlJA1uaXLgcy/OP8/combined_screenshots_with_drawing%20%2811%29.jpg",
      mobileImage: "https://app.milanote.com/media/p/images/1TZlJA1uaXLgcy/OP8/combined_screenshots_with_drawing%20%2811%29.jpg",
      description: "Website Rebuild, Website Hosting and Management, Photography"
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <ScrollReveal>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-semibold mb-4">
              A Few of Our Favorite Projects
            </h2>
          </ScrollReveal>
          <ScrollReveal delay={150}>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              See how we've helped businesses like yours create stunning digital experiences that convert.
            </p>
          </ScrollReveal>
        </div>

        <div className="grid lg:grid-cols-2 xl:grid-cols-3 gap-8 mb-12">
          {projects.map((project, index) => (
            <ScrollReveal key={index} delay={200 * index}>
              <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 group">
                <div className="relative">
                  {/* Desktop Preview */}
                  <div className="relative bg-gray-100 p-4">
                    <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                      <div className="flex items-center space-x-2 p-3 bg-gray-50 border-b">
                        <div className="w-3 h-3 rounded-full bg-red-400"></div>
                        <div className="w-3 h-3 rounded-full bg-yellow-400"></div>
                        <div className="w-3 h-3 rounded-full bg-green-400"></div>
                      </div>
                      <img 
                        src={project.desktopImage} 
                        alt={`${project.title} desktop view`}
                        className="w-full h-32 object-cover"
                      />
                    </div>
                  </div>
                  
                  {/* Mobile Preview Overlay */}
                  <div className="absolute bottom-4 right-4 w-16 bg-white rounded-lg shadow-lg overflow-hidden border-2 border-gray-200">
                    <img 
                      src={project.mobileImage} 
                      alt={`${project.title} mobile view`}
                      className="w-full h-20 object-cover"
                    />
                  </div>

                  {/* Hover Overlay */}
                  <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                    <Button className="bg-white text-black hover:bg-gray-100">
                      View Project
                      <ExternalLink className="ml-2 h-4 w-4" />
                    </Button>
                  </div>
                </div>
                
                <div className="p-6">
                  <div className="text-sm text-blue-600 font-medium mb-2">{project.category}</div>
                  <h3 className="text-xl font-semibold mb-2">{project.title}</h3>
                  <p className="text-gray-600 text-sm">{project.description}</p>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>

        <div className="text-center">
          <ScrollReveal delay={600}>
            <Button variant="outline" size="lg" className="border-black text-black hover:bg-black hover:text-white">
              See Our Complete Portfolio
              <ExternalLink className="ml-2 h-4 w-4" />
            </Button>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
};

export default ShowcaseSection;
